import { imageLoader } from "../../../utils/imageLoader";
import moment from "moment";
import useFavorites from "../../../utils/useFavorites";

const ListeProgrammesEnregistres = ({
  programmesFavoris,
  onProgramClick,
  filterInput,
  setFilterInput,
}) => {
  const {
    favorites,
    isProgramInFavorites,
    handleAddToFavorites,
    isLotInFavorites,
  } = useFavorites();
  return (
    <div>
      {" "}
      <div className="table mt-4">
        {/* Header */}
        <div className="table-fav-prog-header pink text-center ">
          <div className="table-cell">Programme</div>
          <div className="table-cell">Livraison</div>
          <div className="table-cell">Actabilité</div>
          <div className="table-cell">Dispositif</div>
          <div className="table-cell">Lots dispo.</div>
          <div className="table-cell">Typologies</div>
          <div className="table-cell">Prix/m²</div>
          <div className="table-cell">Favoris</div>
        </div>
        {/* Rows */}
        {programmesFavoris?.length > 0 ? (
          programmesFavoris.map((programme) => (
            <div
              key={programme.documentId}
              className="tables-rows-fav-prog cursor-pointer hoverborder"
              onClick={() => onProgramClick(programme.documentId)}
            >
              {/* Programme */}
              <div className="table-cells p-0">
                <div className="d-flex align-items-center gap-2 p-0 radiusTL5 radiusBL5">
                  <div className="program-image">
                    <img
                      src={imageLoader(
                        programme.lots[0]?.images[0]?.image[0]?.url
                      )}
                      alt=""
                    />
                  </div>
                  <div className="d-flex flex-column text-start gap16">
                    <div>
                      <p
                        className="mb-0 fs16 darkGrey semibold name-column"
                        title={programme.name}
                      >
                        {programme.name}
                      </p>
                      <p className="text-muted mb-0 fs11 darkGrey regular">
                        {programme.address || "NC"}
                      </p>
                    </div>
                    <div>
                      <p className="mb-0 fs11 darkGrey semibold">
                        {programme.municipality || "NC"}
                      </p>
                      <p className="text-muted mb-0 fs11 darkGrey regular">
                        {programme.delivery_date
                          ? moment(programme.delivery_date).format("YYYY") +
                            " T-" +
                            moment(programme.delivery_date).quarter()
                          : "NC"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {/* Livraison */}
              <div className="table-cells text-center d-flex align-items-center justify-content-center">
                {programme.delivery_date
                  ? moment(programme.delivery_date).format("YYYY") +
                    " T-" +
                    moment(programme.delivery_date).quarter()
                  : "NC"}
              </div>
              {/* Actabilité */}
              <div className="table-cells text-center d-flex align-items-center justify-content-center">
                {programme.is_actable ? "Immédiate" : "Pas Précisé"}
              </div>
              {/* Dispositif */}
              <div className="table-cells d-flex align-items-center justify-content-center">
                <div className="d-flex flex-column gap-2">
                  <span className="badge bg-green">{"Droit commun"}</span>
                  <div className="d-flex justify-content-between">
                    {["PTZ", "RP neuf"].map((badge, index) => (
                      <span
                        key={index}
                        className={`badge bg-${badge
                          .toLowerCase()
                          .replace(/\s+/g, "-")}`}
                      >
                        {badge}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
              {/* Lots Dispo */}
              <div className="table-cells text-center d-flex align-items-center justify-content-center">
                {programme?.lots?.length ? programme?.lots?.length : "NC"}
              </div>
              {/* Typologies */}
              <div className="table-cells text-center d-flex align-items-center justify-content-center">
                {programme.typologies || "T1-T2-T3-T4"}
              </div>
              {/* Prix */}
              <div className="table-cells d-flex align-items-center justify-content-center">
                <div className="text-center">
                  <p className="text-muted fs16 semibold darkGrey">
                    De{" "}
                    {programme?.lots[0]?.price_total
                      ? Intl.NumberFormat("fr-FR").format(
                          programme?.lots[0]?.price_total
                        )
                      : "NC"}
                  </p>
                  <p className="mb-0 fs16 semibold darkGrey">
                    à{" "}
                    {programme?.lots[programme?.lots?.length - 1]?.price_total
                      ? Intl.NumberFormat("fr-FR").format(
                          programme?.lots[programme?.lots?.length - 1]
                            ?.price_total
                        )
                      : "NC"}
                  </p>
                </div>
              </div>
              {/* Action */}
              <div className="table-cells text-center d-flex align-items-center justify-content-center">
                <img
                  src={
                    isProgramInFavorites(programme.documentId)
                      ? "./icons/favorite-filled.svg"
                      : "./icons/favorite-outline.svg"
                  }
                  alt="favorite"
                  height={35}
                  width={35}
                  className="cursor-pointer p-0"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleAddToFavorites(programme.documentId, "Programme");
                  }}
                />
              </div>
            </div>
          ))
        ) : (
          <div className="text-center">Pas de programmes favoris</div>
        )}
      </div>
    </div>
  );
};

export default ListeProgrammesEnregistres;
